import * as types from "./actionTypes";

export const markDocumentReadCPI = (documentFilename) => ({
  type: types.MARK_DOCUMENT_READ_CPI,
  payload: documentFilename,
});

export const setCPIReadingLoading = (isLoading) => {
  return {
    type: types.SET_CPI_READING_LOADING,
    payload: isLoading,
  };
};
